import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Spinner
} from "reactstrap";

import {
  AvForm,
  AvField
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb

import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import showNotification from "../../../../helpers/show_notification";

import { postSubmitForm } from "../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import { checkOutOfStock } from "../../../../helpers/po_helper";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
const animatedComponents = makeAnimated();

const ItemTransferInventory_ByBranch = (props) => {
  const storeName = localStorage.getItem("store_name")
  const refForForm = useRef(null);

  useEffect(() => {
    loadAllBranches();
  }, []);

  const refSelectBranch = useRef(null);
  const [allFromBranches, setAllFromBranches] = useState();
  const [selectedFromBranch, setSelectedFromBranch] = useState();


  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter(
        (store) =>
          (store.type === "Branch") &&
          store.name !== storeName
      );
      setAllFromBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    if (selectedFromBranch) {
      refSelectBranchItem.current.select.clearValue();
      setSelectedBranchItem();
      loadAllBranchItems();
    }
  }, [selectedFromBranch]);

  const refSelectBatch = useRef(null);
  const refSelectBranchItem = useRef(null);
  const [allBranchItems, setAllBranchItems] = useState([]);
  const [selectedBranchItem, setSelectedBranchItem] = useState();
  const loadAllBranchItems = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "branchitems/get_by_branch_for_transfer";
    let response = await postSubmitForm(url, {
      branch_id: selectedFromBranch._id,
    });
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setAllBranchItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    if (selectedBranchItem) {
      // refSelectBatch.current.select.clearValue();
      setSelectedBatch();
      loadAllBranchItemBatches();
    }
  }, [selectedBranchItem]);
  const [allBatches, setAllBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const loadAllBranchItemBatches = async () => {
    let url =
      process.env.REACT_APP_BASEURL +
      "branchiteminventories/get_by_item_branch";
    let response = await postSubmitForm(url, {
      branch_id: selectedFromBranch._id,
      item_id: selectedBranchItem.item_id,
    });
    if (response.status === 1) {
      setAllBatches(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [remarks, setRemarks] = useState();
  const [itemsForTransfer, setItemsForTransfer] = useState([]);


  const handleAddItem = async (quantity) => {
    var new_array_items = JSON.parse(JSON.stringify(itemsForTransfer));
    const existing_item = new_array_items.filter(function (item) {
      return item.batch === selectedBatch.batch;
    });
    let totalEntered = convertToLowestUnit(selectedBranchItem.unit_levels, quantity);
    let totalAvailable =   convertToLowestUnit(selectedBranchItem.unit_levels, selectedBatch.quantity) 
    if( totalEntered >  totalAvailable  ) {
      showNotification("Can not enter more than available in batch","Warning");
      return 
    }
    let convertedQuantity = GetUpdatedDelivered(quantity,selectedBranchItem.unit_levels)
    if (existing_item.length > 0) {
      showNotification(
        props.t("This item batch is already added."),
        props.t("Error")
      );
    } else if (selectedBatch) {
      let item_to_add = {};
      item_to_add.item_id = selectedBranchItem.item_id;
      item_to_add.batch = selectedBatch.batch;
      item_to_add.name = selectedBranchItem.name;
      item_to_add.category = selectedBranchItem.category;
      // item_to_add.unit_for_po = selectedBranchItem.unit_for_po;
      item_to_add.unit_for_threshold = selectedBranchItem.unit_for_threshold;
      item_to_add.sub_category = selectedBranchItem.sub_category;
      item_to_add.brand = selectedBranchItem.brand;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedBranchItem.unit_levels;
      item_to_add.expiry_date = selectedBatch.expiry_date;
      item_to_add.cost_price = selectedBranchItem.cost_price;
      item_to_add.selling_price = selectedBranchItem.selling_price;
      setItemsForTransfer([...itemsForTransfer, item_to_add]);
      handleCloseModal()
      setSelectedBranchItem();
      refSelectBranchItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        item_details: itemsForTransfer,
        remarks: v.remarks,
        branch_from: {
          branch_id: selectedFromBranch._id,
          name: selectedFromBranch.name,
          email: selectedFromBranch.email,
          mobile: selectedFromBranch.mobile,
        },
      };
      let url =
        process.env.REACT_APP_BASEURL + "itemtransferorders/insert_by_branch";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setIsDisabled(false)
        setRemarks();
        setItemsForTransfer([]);
        setSelectedBranchItem();
        refSelectBranchItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error.message, "Error");
    }
  };
  const handleDeleteRow = (batch) => {
    setItemsForTransfer((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.batch !== batch);
      return updatedCartItems;
    });
  };
  const columns = [
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
    },
    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
               return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';

      },
    },
    {
      text: props.t("Transfer Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
                {formatUnitsForReport(row.quantity)}
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.batch)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleSelectBatch(e) {
    setSelectedBatch(e)
    setSelectUnitModal(!selectUnitModal)
  }

  function handleCloseModal() {

    setSelectUnitModal(false);
    setSelectedBatch()
    setSelectedRowsUnit([])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Transfer")}
            title={props.t("Branch Inv. Transfer")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("New Transfer")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={handleAddItem}
                    ref={refForForm}
                  >
                    <CardTitle>{props.t("Inter-Branch Transfer")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Enter the following details to initiate inter-branch transfer of items"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={4}>
                        <Label>{props.t("From Branch")}</Label>
                        <Select
                          ref={refSelectBranch}
                          value={selectedFromBranch}
                          onChange={(selected) => {
                            setSelectedFromBranch(selected);
                          }}
                          options={allFromBranches}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      {selectedFromBranch && (
                        <Col lg={4}>
                          <Label>{props.t("Item")}</Label>
                          <Select
                            ref={refSelectBranchItem}
                            value={selectedBranchItem}
                            onChange={(selected) => {
                              setSelectedBranchItem(selected);
                            }}
                            options={allBranchItems}
                            classNamePrefix="select2-selection"
                            components={animatedComponents}
                            required
                          />
                        </Col>
                      )}
                      {selectedBranchItem && (
                        <>
                          <Col lg={2}>
                            <br />
                            <Label>Available Quantity</Label>
                            <br />
                            <Label>
                              {formatUnitsForReport(selectedBranchItem?.available,selectedBranchItem?.unit_levels)}
                            </Label>
                          </Col>
                          <Col lg={2}>
                            <br />
                            <Label>Threshold Quantity</Label>
                            <br />
                            <Label>
                              {selectedBranchItem?.threshold +
                                " " +
                                selectedBranchItem?.unit_for_threshold}
                            </Label>
                          </Col>
                        </>
                      )}

                    </Row>

                    {selectedBranchItem && checkOutOfStock(selectedBranchItem?.available) ? (
                      <Col lg={6}>
                        <p class="text-muted mb-2">&nbsp;</p>
                        <div class="alert alert-danger fade show text-center" role="alert">
                          {props.t("This item is out of stock.")}
                        </div>
                      </Col>
                    )
                      : (
                        selectedBranchItem && (
                          <Row>
                            <Col lg={4}>
                              <br />
                              <Label>{props.t("Batch")}</Label>
                              <Select
                                ref={refSelectBatch}
                                value={selectedBatch && selectedBatch}
                                key={selectedBatch}
                                onChange={(e) => { handleSelectBatch(e) }} options={allBatches && allBatches}
                                classNamePrefix="select2-selection"
                                required
                              />
                            </Col>
                          </Row>
                        )

                      )
                    }


                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                  <hr />
                  {itemsForTransfer && itemsForTransfer.length > 0 && (
                    <>
                      <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={itemsForTransfer && itemsForTransfer}
                        columns={columns}
                        noDataIndication="No data to display."
                        striped
                        hover
                        condensed
                      />
                      <AvForm onValidSubmit={handleValidSubmit}>
                        <Row>
                          <Col lg={6}>
                            <AvField
                              name="remarks"
                              value={remarks}
                              onChange={(e) => {
                                setRemarks(e.target.value);
                              }}
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>
                          <Col lg={12}>
                            <hr />
                            <FormGroup className="mb-0 text-left">
                              <div>
                                <Button
                                  type="submit"
                                  color="primary"
                                  style={{ width: '100px' }} 
                                  className="mr-1"
                                  disabled={isDisabled}
                                >
                                 {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>


        {/* Add unit modal  */}

        <EnterQuantityModal
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddItem}
            item={selectedBranchItem}
            checkLimitFor={"batch"}
            selectedBatch={selectedBatch}
          />
      </div>
    </React.Fragment>
  );
};
export default withRouter(
  connect(null, {})(withNamespaces()(ItemTransferInventory_ByBranch))
);
